import axios from 'axios';

export const sendAuthorizationCodeToClient = (
  companyName: string,
  phoneNumber: string
) => {
  axios({
    url: `/dietly/open/phone-number/verification-code?phoneNumber=${phoneNumber}`,
    method: 'POST',
    headers: {
      'company-id': companyName,
    },
  }).catch(err => {
    console.log(err);
  });
};

export const validateClientAuthorizationCode = (
  companyName: string,
  phoneNumber: string,
  verificationCode: string
) =>
  axios({
    url: `/dietly/open/phone-number/confirmation?phoneNumber=${phoneNumber}&verificationCode=${verificationCode}`,
    method: 'POST',
    headers: {
      'company-id': companyName,
    },
  });

export const countriesToShow = [
  'AD',
  'AE',
  'AF',
  'AL',
  'AM',
  'AO',
  'AR',
  'AT',
  'AU',
  'AZ',
  'BA',
  'BE',
  'BG',
  'BR',
  'BY',
  'CA',
  'CH',
  'CL',
  'CN',
  'CO',
  'CY',
  'CZ',
  'DE',
  'DK',
  'DZ',
  'EC',
  'EE',
  'EG',
  'ES',
  'FI',
  'FR',
  'GB',
  'GE',
  'GL',
  'GR',
  'HK',
  'HR',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JP',
  'KE',
  'KP',
  'KR',
  'KZ',
  'LI',
  'LT',
  'LU',
  'LV',
  'MA',
  'MC',
  'MD',
  'ME',
  'MK',
  'MN',
  'MT',
  'MV',
  'MX',
  'MY',
  'NL',
  'NO',
  'NZ',
  'PE',
  'PH',
  'PK',
  'PL',
  'PR',
  'PS',
  'PT',
  'PY',
  'QA',
  'RO',
  'RS',
  'RU',
  'SA',
  'SE',
  'SG',
  'SI',
  'SK',
  'SM',
  'SN',
  'SZ',
  'TH',
  'TN',
  'TR',
  'TW',
  'UA',
  'US',
  'UY',
  'VA',
  'VE',
  'VN',
];
